import './BasicButton.scss';
import LoadingSpinner from '../LoadingSpinner';
import { useCallback } from 'react';

const BasicButton = (props: {
  text: string;
  type: 'primary' | 'secondary' | 'warning';
  working?: boolean;
  disabled?: boolean;
  onClick: () => void;
}) => {
  const handler = useCallback(() => {
    if (!props.disabled) {
      setTimeout(() => props.onClick(), 200);
    }
  }, [ props ]);
  return (
    <button type="button" disabled={ props.disabled }
      className={ `basic-button ${ props.type }${ props.working ? ' working' : '' }` }
      onClick={ handler }>
      { props.working ? (
        <div style={ { filter: props.type === 'secondary' ? 'none' : 'invert(1)' } }>
          <LoadingSpinner />
        </div>
      ) : <h2>{ props.text }</h2> }
    </button>
  );
};

export default BasicButton;
